/* eslint-disable @typescript-eslint/naming-convention */
// TODO: fix naming conventions warnings
export enum TournGroupTypes {
  'TournGroup_None' = 0,
  'TournGroup_DailyMarathon' = 1, // missing image
  'TournGroup_Daily500' = 2, // missing image
  'TournGroup_Knockouts' = 3,
  'TournGroup_BountyBuilders' = 4,
  'TournGroup_BubbleRush' = 5,
  'TournGroup_Fifty50' = 6,
  'TournGroup_MultiStack' = 7,
  'TournGroup_Phased' = 8,
  'TournGroup_JumboShrimp' = 9,
  'TournGroup_Shootouts' = 10,
  'TournGroup_Splash' = 11,
  'TournGroup_TimeTourneys' = 12,
  'TournGroup_WinTheButton' = 13,
  'TournGroup_TripleThreat' = 14,
  'TournGroup_ThursdayThrill' = 15,
  'TournGroup_FatThursday' = 16,
  'TournGroup_SuperTuesday' = 17,
  'TournGroup_FastFriday' = 18,
  'TournGroup_DoubleDuece' = 19,
  'TournGroup_TurboSeries' = 20,
  'TournGroup_Omania' = 21,
  'TournGroup_TheHotTurbos' = 22,
  'TournGroup_TheDailyBigs' = 23,
  'TournGroup_SundayBillion' = 24,
  'TournGroup_SundayMillion' = 25,
  'TournGroup_SundayWarmUp' = 26,
  'TournGroup_SundayStorm' = 27,
  'TournGroup_SundayKickoff' = 28,
  'TournGroup_SundaySupersonic' = 29,
  'TournGroup_SundayShowdown' = 30,
  'TournGroup_SaturdayMicro' = 31,
  'TournGroup_SaturdayEliminator' = 32,
  'TournGroup_SaturdaySplash' = 33,
  'TournGroup_SaturdayKO' = 34,
  'TournGroup_SaturdayDuel' = 35,
  'TournGroup_SaturdaySpeedway' = 36,
  'TournGroup_WomensSunday' = 37,
  'TournGroup_WCOOP' = 38,
  'TournGroup_SCOOP' = 39,
  'TournGroup_PacificRimSpecial' = 40,
  'TournGroup_MicroMadness' = 41,
  'TournGroup_SaturdaySlam' = 42,
  'TournGroup_SaturdayRebuy' = 43,
  'TournGroup_SaturdaySpider' = 44,
  'TournGroup_SaturdayScuffle' = 45,
  'TournGroup_SundayStarter' = 46,
  'TournGroup_SundaySlam' = 47,
  'TournGroup_SundayMarathon' = 48,
  'TournGroup_SundayRebuy' = 49,
  'TournGroup_SundayHighRoller' = 50,
  'TournGroup_Sunday500' = 51,
  'TournGroup_SundayStack' = 52,
  'TournGroup_SundayCooldown' = 53,
  'TournGroup_SundayWrapUp' = 54,
  'TournGroup_SundaySpecial' = 55,
  'TournGroup_SundayHORSE' = 56,
  'TournGroup_High_Roller_Club' = 57,
  'TournGroup_Sunday_Million_Anniversary' = 58,
  'TournGroup_Sunday_Storm_Anniversary' = 59,
  'TournGroup_MicroMillions' = 60,
  'TournGroup_Battle_Royale' = 61, // missing
  'TournGroup_Monday_6Max' = 62,
  'TournGroup_Fat_Tuesday' = 63,
  'TournGroup_All_In_Shootout' = 64,
  'TournGroup_Micro_Series' = 65,
  'TournGroup_SECOOP' = 66,
  'TournGroup_NJSCOOP' = 67,
  'TournGroup_NJCOOP' = 68,
  'TournGroup_ICOOP' = 69,
  'TournGroup_KO_Fever' = 70,
  'TournGroup_Nightly_Stars' = 71,
  'TournGroup_Change_Up' = 72,
  'TournGroup_Moonlight_Express' = 73,
  'TournGroup_Galactic_Series' = 74,
  'TournGroup_Sunday_Storm_Rebuy' = 75,
  'TournGroup_The_Storm_Rebuy' = 76,
  'TournGroup_Super_Thursday_Storm' = 77,
  'TournGroup_SuperStack' = 78,
  'TournGroup_Jab' = 79,
  'TournGroup_Hook' = 80,
  'TournGroup_Uppercut' = 81,
  'TournGroup_Ultra_KO' = 82,
  'TournGroup_Afternoon_on_Stars' = 83,
  'TournGroup_El_Clasico' = 84,
  'TournGroup_O_Clasico' = 85, // missing
  'TournGroup_Super_Thursday' = 86,
  'TournGroup_Super_Thursday_Uppercut' = 87,
  'TournGroup_Super_Thursday_Bigger' = 88,
  'TournGroup_Super_Thursday_Night_on_Stars' = 89,
  'TournGroup_Super_Thursday_6th_Sense' = 90,
  'TournGroup_Super_Thursday_Hot_BigStack_Turbo' = 91,
  'TournGroup_Super_Thursday_Omaha' = 92,
  'TournGroup_Super_Thursday_Midnight_Express' = 93,
  'TournGroup_Super_Monday' = 94, // missing
  'TournGroup_Super_Monday_Uppercut' = 95,
  'TournGroup_Super_Monday_Bigger' = 96,
  'TournGroup_Super_Monday_Night_on_Stars' = 97,
  'TournGroup_Super_Monday_6th_Sense' = 98,
  'TournGroup_Super_Monday_Hot_BigStack_Turbo' = 99,
  'TournGroup_Super_Monday_Omaha' = 100,
  'TournGroup_Super_Monday_Midnight_Express' = 101,
  'TournGroup_Sunday_6Max' = 102,
  'TournGroup_Sunday_Omaha_HiLo' = 103,
  'TournGroup_Sunday_Omaha' = 104,
  'TournGroup_Sunday_Evening' = 105,
  'TournGroup_Sunday_Full_KO' = 106,
  'TournGroup_Sunday_Special_Knockout' = 107,
  'TournGroup_Sunday_Challenge' = 108,
  'TournGroup_Sunday_Micro' = 109,
  'TournGroup_Sunday_Zoom' = 110,
  'TournGroup_Sunday_Mini' = 111,
  'TournGroup_6Max_Club' = 112,
  'TournGroup_Full_KO' = 113,
  'TournGroup_EPT' = 114,
  'TournGroup_EPT_Prague' = 115,
  'TournGroup_EPT_Sochi' = 116,
  'TournGroup_EPT_Monte_Carlo' = 117,
  'TournGroup_EPT_Barcelona' = 118,
  'TournGroup_PCA' = 119,
  'TournGroup_Macau_Poker_Cup' = 120,
  'TournGroup_APPT' = 121,
  'TournGroup_APPT_Manila' = 122,
  'TournGroup_APPT_Macau' = 123,
  'TournGroup_APPT_Korea' = 124,
  'TournGroup_PokerStars_MEGASTACK' = 125,
  'TournGroup_MEGASTACK_UK_Ireland' = 126,
  'TournGroup_MEGASTACK_London' = 127,
  'TournGroup_MEGASTACK_Dublin' = 128,
  'TournGroup_MEGASTACK_France' = 129,
  'TournGroup_MEGASTACK_GujanMestras' = 130,
  'TournGroup_MEGASTACK_Le_Grande_Motte' = 131,
  'TournGroup_MEGASTACK_Italy' = 132,
  'TournGroup_MEGASTACK_Sanremo' = 133,
  'TournGroup_MEGASTACK_Belgium' = 134,
  'TournGroup_MEGASTACK_Namur' = 135,
  'TournGroup_Live_Satellites' = 136,
  'TournGroup_Promo1' = 137,
  'TournGroup_Promo2' = 138,
  'TournGroup_Promo3' = 139,
  'TournGroup_Promo4' = 140,
  'TournGroup_Promo5' = 141,
  'TournGroup_Promo6' = 142,
  'TournGroup_Promo7' = 143,
  'TournGroup_Promo8' = 144,
  'TournGroup_Promo9' = 145,
  'TournGroup_Promo10' = 146,
  'TournGroup_Wednesday_WTB' = 147,
  'TournGroup_Winter_Series' = 148,
  'TournGroup_Summer_Series' = 149,
  'TournGroup_PACOOP' = 150,
  'TournGroup_PASCOOP' = 151,
  'TournGroup_sagpromo1' = 152,
  'TournGroup_sagpromo2' = 153,
  'TournGroup_sagpromo3' = 154,
  'TournGroup_sagpromo4' = 155,
  'TournGroup_sagpromo5' = 156,
  'TournGroup_sagpromo6' = 157,
  'TournGroup_sagpromo7' = 158,
  'TournGroup_sagpromo8' = 159,
  'TournGroup_sagpromo9' = 160,
  'TournGroup_sagpromo10' = 161,
  'TournGroup_lobbygroup1' = 162,
  'TournGroup_lobbygroup2' = 163,
  'TournGroup_lobbygroup3' = 164,
  'TournGroup_lobbygroup4' = 165,
  'TournGroup_lobbygroup5' = 166,
  'TournGroup_lobbygroup6' = 167,
  'TournGroup_lobbygroup7' = 168,
  'TournGroup_lobbygroup8' = 169,
  'TournGroup_lobbygroup9' = 170,
  'TournGroup_lobbygroup10' = 171,
  'TournGroup_HighRollers' = 172,
  'TournGroup_BountyBuilderSeries' = 173,
  'TournGroup_CarnivalSeries' = 174,
  'TournGroup_BSOP' = 175,
  'TournGroup_APPTJeju' = 176,
  'TournGroup_FreerollSeries' = 177,
  'TournGroup_Freeroll' = 178,
  'TournGroup_IMIN_Freeroll' = 179,
  'TournGroup_Night_On_Stars' = 180,
  'TournGroup_INCOOP' = 181,
  'TournGroup_INSCOOP' = 182,
  'TournGroup_Stadium_Series' = 183,
  'TournGroup_Carnaval_Series' = 184,
  'TournGroup_30_30' = 185,
  'TournGroup_20_20' = 186,
  'TournGroup_50_50' = 187,
  'TournGroup_EPT_Online' = 188,
  'TournGroup_Sunday_Majors' = 189,
  'TournGroup_Saturday_Line_Up' = 190,
  'TournGroup_Women_Event' = 191,
  'TournGroup_Blowout_Series' = 192,
  'TournGroup_MICOOP' = 193,
  'TournGroup_MISCOOP' = 194,
  'TournGroup_TRIO_Series' = 195,
  'TournGroup_Football_Phase' = 196,
  'TournGroup_KO_Sunday' = 197,
  'TournGroup_Sunday_Stackosaurus' = 198,
  'TournGroup_Sunday_Brawl' = 199,
  'TournGroup_Sunday_Titan' = 200,
  'TournGroup_Sunday_Rumble' = 201,
  'TournGroup_Saturday_Showdown' = 202,
  'TournGroup_CardsChat_Freeroll' = 203,
  'TournGroup_Women_Saturday_Heads_Up' = 204,
  'TournGroup_PSPC' = 205,
  'TournGroup_50_50_Series' = 206,
  'TournGroup_Half_Price_Sunday' = 207,
  'TournGroup_MicroMillions_Marathon' = 208,
  'TournGroup_Midstake_Madness' = 209,
  'TournGroup_30_30_KO' = 210,
  'TournGroup_Lex_Live' = 211,
  'TournGroup_UKIPT' = 212,
  'TournGroup_MIWCOOP' = 213,
  'TournGroup_PAWCOOP' = 214,
  'TournGroup_NJWCOOP' = 215,
  'TournGroup_PRESEASON' = 216,
  'TournGroup_Fall_Fest' = 217,
  'TournGroup_ONCOOP' = 218,
  'TournGroup_Wednesday_Storm' = 219,
  'TournGroup_Friday_Night_Fight' = 220,
  'TournGroup_Deepstack_Saturday' = 221,
  'TournGroup_Sunday_Million_DE_Satellite' = 222,
  'TournGroup_Power_Path_Redeem' = 223,
  'TournGroup_PATHSNG2' = 224,
  'TournGroup_PATHMTT2' = 225,
  'TournGroup_PATHMTT3' = 226,
  'TournGroup_PATHMTT4' = 227,
  'TournGroup_Mystery_Bounty' = 228,
  'TournGroup_NAPT_Vegas' = 229,
  'TournGroup_EPT_Cyprus' = 230,
  'TournGroup_Mid_Stakes_Madness' = 231,
  'TournGroup_Summer_Week' = 232,
  'TournGroup_Red_Spade_Pass' = 233,
  'TournGroup_Summer_Festival' = 234,
  'TournGroup_Carnival' = 235,
  'TournGroup_Irish_Open' = 236,
  'TournGroup_EPT_Paris' = 237,
  'TournGroup_New_Year' = 238,
  'TournGroup_Eureka' = 239,
  'TournGroup_FPS' = 240,
  'TournGroup_EPT_London' = 241,
  'TournGroup_Eureka_Rozvadov' = 242,
  'TournGroup_Carnival_Series' = 243,
  'TournGroup_Seasons' = 244,
  'TournGroup_FPS_Monte_Carlo' = 245,
  'TournGroup_FPS_Paris' = 246,
  'TournGroup_25_Days_of_Tournaments' = 247,
  'TournGroup_New_Year_Series' = 248,
  'TournGroup_FPS_Aix_En_Provence' = 249,
  'TournGroup_ESPT_Malaga' = 250,
  'TournGroup_ESPT_Barcelona' = 251,
  'TournGroup_Eureka_Cyprus' = 252,
  'TournGroup_Eureka_Prague' = 253,
  'TournGroup_Last' = 'TournGroup_Eureka_Prague' // !!!please keep up to date
}

export enum TournGroupName {
  'Daily Marathon' = TournGroupTypes.TournGroup_DailyMarathon,
  'Daily 500' = TournGroupTypes.TournGroup_Daily500,
  'knockouts_poker' = TournGroupTypes.TournGroup_Knockouts,
  'bounty_builder' = TournGroupTypes.TournGroup_BountyBuilders,
  'Bubble Rush' = TournGroupTypes.TournGroup_BubbleRush,
  'fifty_50' = TournGroupTypes.TournGroup_Fifty50,
  'Multi-Stack' = TournGroupTypes.TournGroup_MultiStack,
  'Phased' = TournGroupTypes.TournGroup_Phased,
  'Jumbo Shrimp' = TournGroupTypes.TournGroup_JumboShrimp,
  'shootout' = TournGroupTypes.TournGroup_Shootouts,
  'Splash' = TournGroupTypes.TournGroup_Splash,
  'Time Tourneys' = TournGroupTypes.TournGroup_TimeTourneys,
  'Win the Button' = TournGroupTypes.TournGroup_WinTheButton,
  'Triple Threat' = TournGroupTypes.TournGroup_TripleThreat,
  'Thursday Thrill' = TournGroupTypes.TournGroup_ThursdayThrill,
  'Fat Thursday' = TournGroupTypes.TournGroup_FatThursday,
  'Super Tuesday' = TournGroupTypes.TournGroup_SuperTuesday,
  'Fast Friday' = TournGroupTypes.TournGroup_FastFriday,
  'Double Duece' = TournGroupTypes.TournGroup_DoubleDuece,
  'Turbo Series' = TournGroupTypes.TournGroup_TurboSeries,
  'Omania' = TournGroupTypes.TournGroup_Omania,
  'hot_turbos' = TournGroupTypes.TournGroup_TheHotTurbos,
  'daily_bigs' = TournGroupTypes.TournGroup_TheDailyBigs,
  'Sunday Billion' = TournGroupTypes.TournGroup_SundayBillion,
  'Sunday Million' = TournGroupTypes.TournGroup_SundayMillion,
  'Sunday Warm-Up' = TournGroupTypes.TournGroup_SundayWarmUp,
  'Sunday Storm' = TournGroupTypes.TournGroup_SundayStorm,
  'Sunday Kickoff' = TournGroupTypes.TournGroup_SundayKickoff,
  'Sunday Supersonic' = TournGroupTypes.TournGroup_SundaySupersonic,
  'Sunday Showdown' = TournGroupTypes.TournGroup_SundayShowdown,
  'Saturday Micro' = TournGroupTypes.TournGroup_SaturdayMicro,
  'Saturday Eliminator' = TournGroupTypes.TournGroup_SaturdayEliminator,
  'Saturday Splash' = TournGroupTypes.TournGroup_SaturdaySplash,
  'saturday_knockout' = TournGroupTypes.TournGroup_SaturdayKO,
  'Saturday Duel' = TournGroupTypes.TournGroup_SaturdayDuel,
  'Saturday Speedway' = TournGroupTypes.TournGroup_SaturdaySpeedway,
  'sunday_womens' = TournGroupTypes.TournGroup_WomensSunday,
  'WCOOP' = TournGroupTypes.TournGroup_WCOOP,
  'SCOOP' = TournGroupTypes.TournGroup_SCOOP,
  'Pacific Rim Special' = TournGroupTypes.TournGroup_PacificRimSpecial,
  'Micro Madness' = TournGroupTypes.TournGroup_MicroMadness,
  'Saturday Slam' = TournGroupTypes.TournGroup_SaturdaySlam,
  'Saturday Rebuy' = TournGroupTypes.TournGroup_SaturdayRebuy,
  'Saturday Spider' = TournGroupTypes.TournGroup_SaturdaySpider,
  'Saturday Scuffle' = TournGroupTypes.TournGroup_SaturdayScuffle,
  'Sunday Starter' = TournGroupTypes.TournGroup_SundayStarter,
  'Sunday Slam' = TournGroupTypes.TournGroup_SundaySlam,
  'Sunday Marathon' = TournGroupTypes.TournGroup_SundayMarathon,
  'Sunday Rebuy' = TournGroupTypes.TournGroup_SundayRebuy,
  'Sunday High Roller' = TournGroupTypes.TournGroup_SundayHighRoller,
  'Sunday 500' = TournGroupTypes.TournGroup_Sunday500,
  'Sunday Stack' = TournGroupTypes.TournGroup_SundayStack,
  'Sunday Cooldown' = TournGroupTypes.TournGroup_SundayCooldown,
  'Sunday Wrap-Up' = TournGroupTypes.TournGroup_SundayWrapUp,
  'Sunday Special' = TournGroupTypes.TournGroup_SundaySpecial,
  'Sunday HORSE' = TournGroupTypes.TournGroup_SundayHORSE,
  'High Roller Club' = TournGroupTypes.TournGroup_High_Roller_Club,
  'sunday_million_anniverary' = TournGroupTypes.TournGroup_Sunday_Million_Anniversary,
  'Sunday Storm Anniversary' = TournGroupTypes.TournGroup_Sunday_Storm_Anniversary,
  'MicroMillions' = TournGroupTypes.TournGroup_MicroMillions,
  'Battle Royale' = TournGroupTypes.TournGroup_Battle_Royale,
  'Monday 6-Max' = TournGroupTypes.TournGroup_Monday_6Max,
  'Fat Tuesday' = TournGroupTypes.TournGroup_Fat_Tuesday,
  'All In Shootout' = TournGroupTypes.TournGroup_All_In_Shootout,
  'Micro Series' = TournGroupTypes.TournGroup_Micro_Series,
  'SECOOP' = TournGroupTypes.TournGroup_SECOOP,
  'NJSCOOP' = TournGroupTypes.TournGroup_NJSCOOP,
  'NJCOOP' = TournGroupTypes.TournGroup_NJCOOP,
  'ICOOP' = TournGroupTypes.TournGroup_ICOOP,
  'KO Fever' = TournGroupTypes.TournGroup_KO_Fever,
  'Nightly Stars' = TournGroupTypes.TournGroup_Nightly_Stars,
  'Change Up' = TournGroupTypes.TournGroup_Change_Up,
  'Moonlight Express' = TournGroupTypes.TournGroup_Moonlight_Express,
  'Galactic Series' = TournGroupTypes.TournGroup_Galactic_Series,
  'Sunday Storm Rebuy' = TournGroupTypes.TournGroup_Sunday_Storm_Rebuy,
  'The Storm Rebuy' = TournGroupTypes.TournGroup_The_Storm_Rebuy,
  'Super Thursday Storm' = TournGroupTypes.TournGroup_Super_Thursday_Storm,
  'SuperStack' = TournGroupTypes.TournGroup_SuperStack,
  'Jab' = TournGroupTypes.TournGroup_Jab,
  'Hook' = TournGroupTypes.TournGroup_Hook,
  'Uppercut' = TournGroupTypes.TournGroup_Uppercut,
  'Ultra KO' = TournGroupTypes.TournGroup_Ultra_KO,
  'Afternoon on Stars' = TournGroupTypes.TournGroup_Afternoon_on_Stars,
  'El Clasico' = TournGroupTypes.TournGroup_El_Clasico,
  'O Clasico' = TournGroupTypes.TournGroup_O_Clasico,
  'Super Thursday' = TournGroupTypes.TournGroup_Super_Thursday,
  'Super Thursday Uppercut' = TournGroupTypes.TournGroup_Super_Thursday_Uppercut,
  'Super Thursday Bigger' = TournGroupTypes.TournGroup_Super_Thursday_Bigger,
  'Super Thursday Night on Stars' = TournGroupTypes.TournGroup_Super_Thursday_Night_on_Stars,
  'Super Thursday 6th Sense' = TournGroupTypes.TournGroup_Super_Thursday_6th_Sense,
  'super_thursday_bigstack_turbo' = TournGroupTypes.TournGroup_Super_Thursday_Hot_BigStack_Turbo,
  'Super Thursday Omaha' = TournGroupTypes.TournGroup_Super_Thursday_Omaha,
  'Super Thursday Midnight Express' = TournGroupTypes.TournGroup_Super_Thursday_Midnight_Express,
  'Super Monday' = TournGroupTypes.TournGroup_Super_Monday,
  'Super Monday Uppercut' = TournGroupTypes.TournGroup_Super_Monday_Uppercut,
  'Super Monday Bigger' = TournGroupTypes.TournGroup_Super_Monday_Bigger,
  'Super Monday Night on Stars' = TournGroupTypes.TournGroup_Super_Monday_Night_on_Stars,
  'Super Monday 6th Sense' = TournGroupTypes.TournGroup_Super_Monday_6th_Sense,
  'super_monday_bigstack_turbo' = TournGroupTypes.TournGroup_Super_Monday_Hot_BigStack_Turbo,
  'Super Monday Omaha' = TournGroupTypes.TournGroup_Super_Monday_Omaha,
  'Super Monday Midnight Express' = TournGroupTypes.TournGroup_Super_Monday_Midnight_Express,
  'Sunday 6-Max' = TournGroupTypes.TournGroup_Sunday_6Max,
  'Sunday Omaha HiLo' = TournGroupTypes.TournGroup_Sunday_Omaha_HiLo,
  'Sunday Omaha' = TournGroupTypes.TournGroup_Sunday_Omaha,
  'Sunday Evening' = TournGroupTypes.TournGroup_Sunday_Evening,
  'Sunday Full KO' = TournGroupTypes.TournGroup_Sunday_Full_KO,
  'Sunday Special Knockout' = TournGroupTypes.TournGroup_Sunday_Special_Knockout,
  'Sunday Challenge' = TournGroupTypes.TournGroup_Sunday_Challenge,
  'Sunday Micro' = TournGroupTypes.TournGroup_Sunday_Micro,
  'Sunday Zoom' = TournGroupTypes.TournGroup_Sunday_Zoom,
  'Sunday Mini' = TournGroupTypes.TournGroup_Sunday_Mini,
  '6-Max Club' = TournGroupTypes.TournGroup_6Max_Club,
  'Full KO' = TournGroupTypes.TournGroup_Full_KO,
  'EPT' = TournGroupTypes.TournGroup_EPT,
  'EPT Prague' = TournGroupTypes.TournGroup_EPT_Prague,
  'EPT Sochi' = TournGroupTypes.TournGroup_EPT_Sochi,
  'EPT Monte Carlo' = TournGroupTypes.TournGroup_EPT_Monte_Carlo,
  'EPT Barcelona' = TournGroupTypes.TournGroup_EPT_Barcelona,
  'PCA' = TournGroupTypes.TournGroup_PCA,
  'Macau Poker Cup' = TournGroupTypes.TournGroup_Macau_Poker_Cup,
  'APPT' = TournGroupTypes.TournGroup_APPT,
  'APPT Manila' = TournGroupTypes.TournGroup_APPT_Manila,
  'APPT Macau' = TournGroupTypes.TournGroup_APPT_Macau,
  'APPT Korea' = TournGroupTypes.TournGroup_APPT_Korea,
  'PokerStars MEGASTACK' = TournGroupTypes.TournGroup_PokerStars_MEGASTACK,
  'MEGASTACK UK & Ireland' = TournGroupTypes.TournGroup_MEGASTACK_UK_Ireland,
  'MEGASTACK London' = TournGroupTypes.TournGroup_MEGASTACK_London,
  'MEGASTACK Dublin' = TournGroupTypes.TournGroup_MEGASTACK_Dublin,
  'MEGASTACK France' = TournGroupTypes.TournGroup_MEGASTACK_France,
  'MEGASTACK Gujan-Mestras' = TournGroupTypes.TournGroup_MEGASTACK_GujanMestras,
  'MEGASTACK Le Grande Motte' = TournGroupTypes.TournGroup_MEGASTACK_Le_Grande_Motte,
  'MEGASTACK Italy' = TournGroupTypes.TournGroup_MEGASTACK_Italy,
  'MEGASTACK Sanremo' = TournGroupTypes.TournGroup_MEGASTACK_Sanremo,
  'MEGASTACK Belgium' = TournGroupTypes.TournGroup_MEGASTACK_Belgium,
  'MEGASTACK Namur' = TournGroupTypes.TournGroup_MEGASTACK_Namur,
  'Live Satellites' = TournGroupTypes.TournGroup_Live_Satellites,
  'Promo1' = TournGroupTypes.TournGroup_Promo1,
  'Promo2' = TournGroupTypes.TournGroup_Promo2,
  'Promo3' = TournGroupTypes.TournGroup_Promo3,
  'Promo4' = TournGroupTypes.TournGroup_Promo4,
  'Promo5' = TournGroupTypes.TournGroup_Promo5,
  'Promo6' = TournGroupTypes.TournGroup_Promo6,
  'Promo7' = TournGroupTypes.TournGroup_Promo7,
  'Promo8' = TournGroupTypes.TournGroup_Promo8,
  'Promo9' = TournGroupTypes.TournGroup_Promo9,
  'Promo10' = TournGroupTypes.TournGroup_Promo10,
  'Wednesday WTB' = TournGroupTypes.TournGroup_Wednesday_WTB,
  'Winter Series' = TournGroupTypes.TournGroup_Winter_Series,
  'Summer Series' = TournGroupTypes.TournGroup_Summer_Series,
  'PACOOP' = TournGroupTypes.TournGroup_PACOOP,
  'PASCOOP' = TournGroupTypes.TournGroup_PASCOOP,
  'sagpromo1' = TournGroupTypes.TournGroup_sagpromo1,
  'sagpromo2' = TournGroupTypes.TournGroup_sagpromo2,
  'sagpromo3' = TournGroupTypes.TournGroup_sagpromo3,
  'sagpromo4' = TournGroupTypes.TournGroup_sagpromo4,
  'sagpromo5_sag' = TournGroupTypes.TournGroup_sagpromo5,
  'sagpromo6' = TournGroupTypes.TournGroup_sagpromo6,
  'sagpromo7' = TournGroupTypes.TournGroup_sagpromo7,
  'sagpromo8' = TournGroupTypes.TournGroup_sagpromo8,
  'sagpromo9' = TournGroupTypes.TournGroup_sagpromo9,
  'sagpromo10' = TournGroupTypes.TournGroup_sagpromo10,
  'lobbygroup1' = TournGroupTypes.TournGroup_lobbygroup1,
  'lobbygroup2' = TournGroupTypes.TournGroup_lobbygroup2,
  'lobbygroup3' = TournGroupTypes.TournGroup_lobbygroup3,
  'lobbygroup4' = TournGroupTypes.TournGroup_lobbygroup4,
  'lobbygroup5' = TournGroupTypes.TournGroup_lobbygroup5,
  'lobbygroup6' = TournGroupTypes.TournGroup_lobbygroup6,
  'lobbygroup7' = TournGroupTypes.TournGroup_lobbygroup7,
  'lobbygroup8' = TournGroupTypes.TournGroup_lobbygroup8,
  'lobbygroup9' = TournGroupTypes.TournGroup_lobbygroup9,
  'lobbygroup10' = TournGroupTypes.TournGroup_lobbygroup10,
  'High Rollers' = TournGroupTypes.TournGroup_HighRollers,
  'Bounty Builder Series' = TournGroupTypes.TournGroup_BountyBuilderSeries,
  'Carnival Series' = TournGroupTypes.TournGroup_CarnivalSeries,
  'BSOP' = TournGroupTypes.TournGroup_BSOP,
  'APPT Jeju' = TournGroupTypes.TournGroup_APPTJeju,
  'Freeroll Series' = TournGroupTypes.TournGroup_FreerollSeries,
  'Freeroll' = TournGroupTypes.TournGroup_Freeroll,
  'IMIN Freeroll' = TournGroupTypes.TournGroup_IMIN_Freeroll,
  'Night On Stars' = TournGroupTypes.TournGroup_Night_On_Stars,
  'INCOOP' = TournGroupTypes.TournGroup_INCOOP,
  'INSCOOP' = TournGroupTypes.TournGroup_INSCOOP,
  'Stadium Series' = TournGroupTypes.TournGroup_Stadium_Series,
  'Carnaval Series' = TournGroupTypes.TournGroup_Carnaval_Series,
  '30 30' = TournGroupTypes.TournGroup_30_30,
  '20 20' = TournGroupTypes.TournGroup_20_20,
  '50 50' = TournGroupTypes.TournGroup_50_50,
  'EPT Online' = TournGroupTypes.TournGroup_EPT_Online,
  'Sunday Majors' = TournGroupTypes.TournGroup_Sunday_Majors,
  'Saturday Line Up' = TournGroupTypes.TournGroup_Saturday_Line_Up,
  'Women Event' = TournGroupTypes.TournGroup_Women_Event,
  'Blowout Series' = TournGroupTypes.TournGroup_Blowout_Series,
  'MICOOP' = TournGroupTypes.TournGroup_MICOOP,
  'MISCOOP' = TournGroupTypes.TournGroup_MISCOOP,
  'TRIO Series' = TournGroupTypes.TournGroup_TRIO_Series,
  'Football Phase' = TournGroupTypes.TournGroup_Football_Phase,
  'KO Sunday' = TournGroupTypes.TournGroup_KO_Sunday,
  'Sunday Stackosaurus' = TournGroupTypes.TournGroup_Sunday_Stackosaurus,
  'Sunday Brawl' = TournGroupTypes.TournGroup_Sunday_Brawl,
  'Sunday Titan' = TournGroupTypes.TournGroup_Sunday_Titan,
  'Sunday Rumble' = TournGroupTypes.TournGroup_Sunday_Rumble,
  'Saturday Showdown' = TournGroupTypes.TournGroup_Saturday_Showdown,
  'CardsChat Freeroll' = TournGroupTypes.TournGroup_CardsChat_Freeroll,
  'Women Saturday Heads Up' = TournGroupTypes.TournGroup_Women_Saturday_Heads_Up,
  'PSPC' = TournGroupTypes.TournGroup_PSPC,
  '50 50 Series' = TournGroupTypes.TournGroup_50_50_Series,
  'Half Price Sunday' = TournGroupTypes.TournGroup_Half_Price_Sunday,
  'MicroMillions Marathon' = TournGroupTypes.TournGroup_MicroMillions_Marathon,
  'Midstake Madness' = TournGroupTypes.TournGroup_Midstake_Madness,
  '30 30 KO' = TournGroupTypes.TournGroup_30_30_KO,
  'Lex Live' = TournGroupTypes.TournGroup_Lex_Live,
  'UKIPT' = TournGroupTypes.TournGroup_UKIPT,
  'MIWCOOP' = TournGroupTypes.TournGroup_MIWCOOP,
  'PAWCOOP' = TournGroupTypes.TournGroup_PAWCOOP,
  'NJWCOOP' = TournGroupTypes.TournGroup_NJWCOOP,
  'PRESEASON' = TournGroupTypes.TournGroup_PRESEASON,
  'Fall_Fest' = TournGroupTypes.TournGroup_Fall_Fest,
  'ONCOOP' = TournGroupTypes.TournGroup_ONCOOP,
  'Wednesday Storm' = TournGroupTypes.TournGroup_Wednesday_Storm,
  'Friday Night Fight' = TournGroupTypes.TournGroup_Friday_Night_Fight,
  'Deepstack Saturday' = TournGroupTypes.TournGroup_Deepstack_Saturday,
  'Sunday Million DE Satellite' = TournGroupTypes.TournGroup_Sunday_Million_DE_Satellite,
  'Power Path Redeem' = TournGroupTypes.TournGroup_Power_Path_Redeem,
  'PATHSNG2' = TournGroupTypes.TournGroup_PATHSNG2,
  'PATHMTT2' = TournGroupTypes.TournGroup_PATHMTT2,
  'PATHMTT3' = TournGroupTypes.TournGroup_PATHMTT3,
  'PATHMTT4' = TournGroupTypes.TournGroup_PATHMTT4,
  'Mystery Bounty' = TournGroupTypes.TournGroup_Mystery_Bounty,
  'NAPT Vegas' = TournGroupTypes.TournGroup_NAPT_Vegas,
  'EPT Cyprus' = TournGroupTypes.TournGroup_EPT_Cyprus,
  'Mid Stakes Madness' = TournGroupTypes.TournGroup_Mid_Stakes_Madness,
  'Summer Week' = TournGroupTypes.TournGroup_Summer_Week,
  'Red Spade Pass' = TournGroupTypes.TournGroup_Red_Spade_Pass,
  'Summer Festival' = TournGroupTypes.TournGroup_Summer_Festival,
  'Carnival' = TournGroupTypes.TournGroup_Carnival,
  'Irish Open' = TournGroupTypes.TournGroup_Irish_Open,
  'EPT Paris' = TournGroupTypes.TournGroup_EPT_Paris,
  'New Year' = TournGroupTypes.TournGroup_New_Year,
  'Eureka' = TournGroupTypes.TournGroup_Eureka,
  'FPS' = TournGroupTypes.TournGroup_FPS,
  'EPT London' = TournGroupTypes.TournGroup_EPT_London,
  'Eureka Rozvadov' = TournGroupTypes.TournGroup_Eureka_Rozvadov,
  'CarnivalSeries' = TournGroupTypes.TournGroup_Carnival_Series,
  'Seasons' = TournGroupTypes.TournGroup_Seasons,
  'FPS Monte Carlo' = TournGroupTypes.TournGroup_FPS_Monte_Carlo,
  'FPS Paris' = TournGroupTypes.TournGroup_FPS_Paris,
  '25 Days of Tournaments' = TournGroupTypes.TournGroup_25_Days_of_Tournaments,
  'New Year Series' = TournGroupTypes.TournGroup_New_Year_Series,
  'FPS Aix En Provence' = TournGroupTypes.TournGroup_FPS_Aix_En_Provence,
  'ESPT Malaga' = TournGroupTypes.TournGroup_ESPT_Malaga,
  'ESPT Barcelona' = TournGroupTypes.TournGroup_ESPT_Barcelona,
  'Eureka Cyprus' = TournGroupTypes.TournGroup_Eureka_Cyprus,
  'Eureka Prague' = TournGroupTypes.TournGroup_Eureka_Prague
}
